<template>
    <g>
        <rect x="0.5" y="1" width="15" height="15" rx="2.5" fill="white" />
        <rect x="0.5" y="1" width="15" height="15" rx="2.5" stroke="#C8D0DD" />
    </g>
</template>
<script>
export default {
    name: "UnChecked",
};
</script>
